import { computePosition, flip, shift } from "@floating-ui/dom"

if (!Shopify.designMode) {
  class TooltipContent extends HTMLElement {
    constructor() {
      super()
      this.show = this.show.bind(this)
      this.hide = this.hide.bind(this)
    }

    show(triggerElement) {
      this.updatePosition(triggerElement)
      this.setAttribute("data-show", "")

      this.addEventListener("mouseenter", this.handleMouseEnter)
      this.addEventListener("mouseleave", this.handleMouseLeave)
    }

    updatePosition(button) {
      computePosition(button, this, {
        placement: "top",
        middleware: [shift(), flip()],
      }).then(({ x, y }) => {
        Object.assign(this.style, {
          left: `${x}px`,
          top: `${y}px`,
        })
      })
    }

    hide() {
      this.removeAttribute("data-show")

      this.removeEventListener("mouseenter", this.handleMouseEnter)
      this.removeEventListener("mouseleave", this.handleMouseLeave)
    }

    handleMouseEnter() {
      this.classList.add("tooltip--hovered")
    }

    handleMouseLeave() {
      this.classList.remove("tooltip--hovered")
      this.hide()
    }
  }

  if (!customElements.get("tooltip-content")) {
    customElements.define("tooltip-content", TooltipContent)
  }
}
